<template>
	<div>
    <pt-form-item label="是否合格:" labelWidth="145px" :required="true">
      <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
        <el-radio label="REPORT_GENERATE">合格</el-radio>
        <el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="原因:" labelWidth="145px" v-if="form.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'" :required="true">
      <el-input type="textarea" data-vv-as="原因" v-validate="'required'" :rows="2" placeholder="请输入内容" v-model="form.reason"></el-input>
      <!-- <not-qualified-reason-data-analysised data-vv-as="原因" v-validate="'required'" v-model="form.reason" @mousedown.stop.native @click.stop.native></not-qualified-reason-data-analysised> -->
    </pt-form-item>
		<pt-form-item label="上传检测数据:" labelWidth="145px" :required="true" v-if="order.packageProductionType === 'PROPRIETARY' && form.result !== 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'">
      <el-upload ref="qualityFile" class="upload-demo" v-model="form.qualityFile" name="qualityFile" v-validate="'required'" data-vv-as="上传检测数据"
      action="aaa"
      :auto-upload="false"
      :multiple="false"
      :on-change="changHandler">
          <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </pt-form-item>
    <pt-form-item label="实验人员:" labelWidth="145px" :required="true">
       <el-input name="operatorName.SequencingTestOperator" data-vv-as="实验人员" v-validate="'required'" v-model="form.operatorName.SequencingTestOperator" placeholder="请输入实验人员姓名"></el-input>
    </pt-form-item>
    <pt-form-item label="数据分析与报告人员:" labelWidth="145px" :required="true">
       <el-input name="operatorName.Checker1" data-vv-as="数据分析与报告人员姓名" v-validate="'required'" v-model="form.operatorName.Checker1" placeholder="请输入数据分析与报告人员姓名"></el-input>
    </pt-form-item>
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import { next } from '../status.js'
import { getSignature } from '@/utils/action'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  data () {
    return {
      title: '上机检测',
      form: {
        result: 'REPORT_GENERATE',
        reason: '',
        qualityFile: [],
        operatorName: {
          SequencingTestOperator: '',
          Checker1: ''
        }
      },
      // oss里存的路径+名字
      saveFileName: ''
    }
  },
  watch: {
    qualityFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.qualityFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.form.qualityFile = fileList
      console.log('this.form', this.form)
    },
    async next () {
      // 传入表单和文件
      let data = { action: this.status, orderIds: [this.order.id], operatorName: this.form.operatorName }
      if (this.order.packageProductionType !== 'PROPRIETARY' || this.form.result === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION') {
        data.packageProductionType = this.order.packageProductionType
        data.orderStatusDetail = {
          orderStatusResult: this.form.result, // 'REPORT_GENERATE'
          reason: this.form.reason
        }
        return next.call(this, data)
      }
      try {
        let params = { resourceConfig: 'rawdata', type: 'PRIVATE_RESOURCE', objectId: new Date().getTime(), name: this.form.qualityFile[0].name }
        var response = await this.$store.dispatch('ossUploadBigFile', params)
        console.log('response', response.data)
        try {
          this.uploadForm = new FormData()
          this.uploadForm.append('AccessKeyId', response.data.accesskeyid)
          this.uploadForm.append('policy', response.data.policy)
          this.uploadForm.append('signature', response.data.signature)
          this.saveFileName = response.data.key
          this.uploadForm.append('key', response.data.key)
          // this.uploadForm.append('x-obs-acl', response.data['x-obs-acl'])
          this.uploadForm.append('content-type', response.data['content-type'])
          this.uploadForm.append('file', this.form.qualityFile[0].raw)
          // this.uploadForm.append('success_action_status', 200) // 指定返回的状态码，默认为204
          let uploadRes = await getSignature(response.data.host, this.uploadForm)
          if (uploadRes.status === 204) {
            // ---对应字段
            let fileObj = {}
            fileObj.ossUrl = this.saveFileName
            fileObj.type = 'RAW_DATA'
            fileObj.name = this.form.qualityFile[0].name
            data.orderStatusDetail = {}
            data.orderStatusDetail.attachmentFileInformationList = [fileObj]
            data.orderStatusDetail.orderStatusResult = 'REPORT_GENERATE'
            // 打印传入接口的data
            this.form.qualityFile[0].status = 'ready'
            return next.call(this, data)
          } else {
            this.$emit('updateLoading', false)
            this.$message.error('文件上传失败')
          }
        } catch (err) {
          console.log(err)
          this.$emit('updateLoading', false)
          this.$message.error('文件上传失败！')
        }
      } catch (err) {
        console.log(err)
        this.$emit('updateLoading', false)
        this.$message.error('获取签名失败！')
      }
    }
  },
  created () {

  }

}
</script>

<style lang="less">

</style>
